// removed by extract-text-webpack-plugin
module.exports = {"fromBottom":"_2vpX","comeUp":"_3xeW","pulse":"_2q_D"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Animation/Animation.scss
// module id = 51eT
// module chunks = 0